<template>
  <div class="show" v-if="showInfo">
    
    <div class="header">
      <div class="headerbox">
          <img :src="`${IP_TEST}/uploads/${logopic}`" alt="" @click="$router.push('/')">
          <div class="back">
              <a class="light" href="/InqMember">继续查询</a>
            <a href="/">返回页面</a>
        </div>
      
      </div>
    
    </div>
    <div class="box">
      <div class="content">
        <div class="headerinfo">
          <h2>
            培训单位备案信息
          </h2>
          <div class="tip">根据全国职业信用评价网入库标准及规定，您的信息已入库，入库编号是 {{ showInfo.code }}</div>
          <div class="perinfo">企业信息</div>
          <div class="compytitle">
            <h3>
              {{ showInfo.companyname }}
            </h3>
            <p>
              {{ showInfo.address }}
            </p>
          </div>
        </div>
        <div class="codeinfo">
          <img src="/static/img/huiayun.png" alt="">
          <span>备案登记号：<span style="color:#333333;">{{ showInfo.code }}</span></span>
        </div>
        <div class="detailInfo">
          <table width="1143px" align="center">
            <tr>
              <td>法定代表人：</td>
              <td>{{ showInfo.legalperson }}</td>
              <td>信用代码：</td>
              <td>{{ showInfo.socialcreditcode }}</td>
            </tr>
            <tr>
              <td>所属行业：</td>
              <td>{{ showInfo.industry }}</td>
              <td>单位所属地址：</td>
              <td>{{ showInfo.country }}</td>
            </tr>
            <tr>
              <td>单位注册地址：</td>
              <td colspan="3">{{ showInfo.address }}</td>
            </tr>
            <tr>
              <td>备案登记名称：</td>
              <td colspan="3">{{ showInfo.beianname }}</td>
            </tr>
            <tr>
              <td>委员会意见：</td>
              <td colspan="3">{{ showInfo.committeeppinion }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="bacc">版权所有：zhcp.org.cn</div>
  </div>
</template>

<script>
/**
 * 企业证书查询系统模版
 */
import { IP_TEST } from '@/config';
import QRCode from "qrcodejs2";
export default {
  name: "ShowQy",
  data() {
    return {
      IP_TEST
    }
  },
  computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  props: {
    showInfo: Object
  },
  mounted() {
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    download() {
      this.$axios
        .get(`${IP_TEST}/uploads/证书图下载/${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.socialcreditcode}.jpg`, {
          responseType: "blob", //重要
        })
        .then((response) => {
          if ("msSaveOrOpenBlob" in window.navigator) {
            //兼容ie浏览器下载报传递给系统调用的数据区域太小.
            var data = response;
            var blob = new Blob([data], { type: "application/vnd.ms-excel" });
            window.navigator.msSaveOrOpenBlob(blob, `${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.socialcreditcode}.jpg`);
            return;
          } else {
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS&&!this.isWeixinBrowser()) {
              var jpeg = new Blob([response], { type: "image/jpeg" });
              const url = window.URL.createObjectURL(jpeg);
              const link = document.createElement("a");
              let fname = `${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.socialcreditcode}.jpg`;
              link.href = url;
              link.setAttribute("download", fname);
              link.download = fname;
              document.body.appendChild(link);
              link.click();
              return;
            }
            else if(isiOS&&this.isWeixinBrowser())
            {
              var winHeight = $(window).height();
              $(".weixin-tip").css("height",winHeight);
              $(".weixin-tip").show();
              return;
            }
            window.open(
              `${IP_TEST}/bzw/loadimgs?imgpath=证书图下载/${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.socialcreditcode}.jpg`,
              "_blank"
            );
          }
        });
    },
    isWeixinBrowser() {
      return /micromessenger/.test(navigator.userAgent.toLowerCase())
        ? true
        : false;
    },
    isQQBrowser() {
      return /qq/.test(navigator.userAgent.toLowerCase()) ? true : false;
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
    },
    formatExcel(value) {
        if (!value) {
            return "";
        } else {
            if (typeof value == "string") {
                return value.trim();
            } else {
                return value.toString().trim();
            }
        }
    }
  }
};
</script>
<style scoped>
.tip{
  position: relative;
  margin:auto;
  width: 950px;
  padding-left: 193px;
height: 61px;
background: #FFEEED;
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #F24040;
line-height:61px;
background-image: url(/static/img/img/reccet.png);
background-repeat: no-repeat;
background-size: 20px 20px;
background-position: 163px center;
}
.show{
  position: relative;
  width: 100%;
  min-height: 1130px;
  background-color: #EEF0F5;
}
.show .box{
  width: 1300px;
  margin: auto;
  position: relative;
  /* top:47px; */
}
/* header */
.header{
  width: 100%;
  padding:16px 0 16px;

height: auto;
background: #FFFFFF;
box-shadow: 0px 2px 10px 0px rgba(65,65,65,0.09);
}
.headerbox{
  width: 1300px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.headerbox img{
  width:608px;
  /* height:49px; */
}
.headerbox .back{
  float:right;
  width: 258px;
  height: 42px;
border: 1px solid #2F8EEC;
}
.headerbox a{
  display: inline-block;
  width: 129px;
height: 42px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
line-height: 42px;

text-align: center;
}
.headerbox a.light{
background: #2E8EEB;
color: #FFFFFF;
}
/* header */
.content .headerinfo{
  height: 500px;
  margin-top:19px;
  background: #FFFFFF;
}
.content .headerinfo h2{
  /* background-image: url(/static/img/baiotiti.png); */
    /* background-repeat: no-repeat; */
    /* background-size: contain; */
    height: 35px;
    margin: auto;
    position: relative;
    padding: 69px 0 85px;
    font-size: 35px;
    text-align: center;
    line-height: 35px;
    font-weight: bold;
    color: #333333;
}
.content .headerinfo h2::after{
  position: absolute;
  content:'';
  left:631px;
  bottom:48px;
  width: 37px;
height: 8px;
background: #2E8EEB;
border-radius: 3px;
}
.compytitle{
  height: 171px;
  width:1143px;
  margin: auto;
  position: relative;
  /* left: 41px; */
  border-radius: 5px;
}
.compytitle img{
  width: 125px;
}
.compytitle .info{
  padding-top: 10px;
  padding-left:20px;
  width:960px;
  display: inline-block;
}
.compytitle h3{
    font-size: 16px;
  /* font-weight: bold; */
  color: #999999;
  /* letter-spacing: 4px; */
}
.compytitle p{
  color: #999999;
    font-size: 16px;
    font-weight: 400;
    /* letter-spacing: 3px; */
    margin-top: 13px;
    line-height: 33px;
}
.codeinfo{
  margin-top: 18px;
  width: 1300px;
  height: 65px;
  background: #FFFFFF;
  line-height: 65px;
  font-size: 16px;
  color: #999999;
}
.codeinfo img{
  margin-left: 78px;
  margin-right: 12px;
  position: relative;

    top: 19px;
}
.detailInfo{
  padding: 20px 0;
  margin-top:18px;
  width: 1300px;
  min-height: 255px;
  background: #FFFFFF;
  overflow: hidden;
}

.detailInfo td{
  border:1px solid #7B93D0;
  /* padding:5px 15px; */
  min-height: 54px;
  height: 54px;
  padding-left: 32px;
  font-size: 21px;
  line-height: 33px;
}
.detailInfo tr td:nth-child(2n-1){
  font-size: 16px;
color: #999999;
  width: 163px;
}
.detailInfo tr td:nth-child(2n){
  width: 469px;
  font-size: 16px;
  color: #333333;
}
.perinfo .back{
  color: #2E8EEB;
    position: absolute;
    right: 78px;
    font-size: 16px;
    border-bottom: solid 1px;
    line-height: 25px;
}
.perinfo{
  position: relative;
  margin-top: 60px;
  margin-bottom: 42px;
  width: 1216px;
  padding-left: 84px;
height: 24px;
font-size: 24px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
line-height: 24px;
}
.bacc{
  position: relative;
  margin-top:61px;
  text-align: center;
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #000000;
line-height: 14px;
}
</style>